import { RestUrl } from "@/commons/constants/RestUrl";
import UrlFormatter from "@/commons/utils/UrlFormatter";
import CommonService from "@/commons/services/CommonService";
import LoginUser from "@/store/LoginUser";
import { HitomeqErrorType } from "@/commons/models/SystemError";

/**
 * ### 待機者ラベル API 操作クラス
 */
export default class WaiterLabels {
  /** 共通サービス */
  private commonService: CommonService;

  /**
   * ### コンストラクター
   *
   * - 共通サービスが渡されればそれを使用する
   * - 共通サービスが渡されなければ新しいインスタンスを作る
   *
   * @param commonService 共通サービス
   */
  constructor(commonService?: CommonService) {
    this.commonService = commonService ? commonService : new CommonService();
    return;
  }

  /**
   * ### GET WaiterLabels
   */
  public async gets(userStore: LoginUser): Promise<Array<WaiterLabelsGetModel>> {
    const formatParams: any = {
      facilityId: userStore.loginUser.facilityId
    };
    const requestUrl: string = UrlFormatter.format(RestUrl.WaiterLabels, formatParams);

    const response = await this.commonService.executeGet<Array<WaiterLabelsGetModel>>(userStore, requestUrl, this.constructor.name, {}, HitomeqErrorType.REQUEST_RETRY, 0);

    return response.data;
  }

  /**
   * ### PATCH WaiterLabels
   */
  public async patch(userStore: LoginUser, labelId: number, requestBody: WaiterLabelsPatchModel): Promise<any> {
    const formatParams: any = {
      facilityId: userStore.loginUser.facilityId,
      labelId: labelId
    };
    const requestUrl: string = UrlFormatter.format(RestUrl.WaiterLabel, formatParams);

    const response = await this.commonService.executePatch<any>(userStore, requestUrl, requestBody, this.constructor.name, HitomeqErrorType.REQUEST_RETRY, 0);

    return response.data;
  }
}

export interface WaiterLabelsGetModel {
  /** 施設ID */
  facilityId: number;
  /** システムで一意に特定するための ID */
  id: number;

  /** ラベル名 */
  name: string;
  /** 文字色 */
  color: string;
  /** 背景色 */
  bgColor: string;
  /** 説明文 */
  description: string;
  /** 使用可否 */
  use: boolean;

  /** 論理削除フラグ */
  deleteFlag: boolean;
  /** 更新日時 (YYYYMMDDhhmmssSSS) */
  updated: number;
  /** 作成日時 (YYYYMMDDhhmmssSSS) */
  created: number;
}

export interface WaiterLabelsPatchModel {
  /** ラベル名 */
  name: string;
  /** 説明文 */
  description: string;
  /** 文字色 */
  color: string;
  /** 背景色 */
  bgColor: string;
  /** 使用可否 */
  use: boolean;
  /** 更新日時 (YYYYMMDDhhmmssSSS) */
  updated: number;
}
